import { eHierarchyLevel } from "functions/api/enums";

export interface TlfLinkLocation {
  linkHierarchyName: string;
  linkLevel: eHierarchyLevel;
  linkHierarchyId: string;
}

/**
 * Type guard to verify an object is a `TlfLinkLocation`.
 *
 * @param obj - Value to inspect for `TlfLinkLocation` shape.
 * @returns True when the object matches the `TlfLinkLocation` interface.
 */
export const isTlfLinkLocation = (obj: unknown): obj is TlfLinkLocation => {
  return (
    // Check object
    typeof obj === "object" &&
    obj !== null &&
    // Check properties exist
    "linkHierarchyName" in obj &&
    "linkLevel" in obj &&
    "linkHierarchyId" in obj &&
    // Check properties types
    typeof (obj as TlfLinkLocation).linkHierarchyName === "string" &&
    Object.values(eHierarchyLevel).includes((obj as TlfLinkLocation).linkLevel) &&
    // Check enums
    typeof (obj as TlfLinkLocation).linkHierarchyId === "string" &&
    (obj as TlfLinkLocation).linkLevel in eHierarchyLevel
  );
};
